import React from "react";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";

import SearchResultItem from "../components/SearchResultItem";
import SearchResultItemRepository from "../components/SearchResultItemRepository";
import Spinner from '../components/Spinner'
import { SET_SEARCH_ITEM } from "../actions/actionTypes";

const SearchResults = ({ data, fetchData, history, isRepository }) => {
    const dispatch = useDispatch();
    const searchState = useSelector(state => state.search);
    isRepository = searchState.isRepository;
  
    const openItem = item => {
      dispatch({ type: SET_SEARCH_ITEM, payload: item });

      if (isRepository) {
        history.push(`/item-repository/${item.id}`);
      } else {
        history.push(`/item/${item['registro-sistema']}`);
      }
    };
  
    return (
      <InfiniteScroll
        dataLength={data.results.length}
        next={fetchData}
        hasMore={data.hasMoreResults}
        loader={<Spinner />}
      >
        {data.results.map((item, index) => (
            isRepository ?
            <SearchResultItemRepository
                item={item}
                key={index}
                index={index}
                onClick={() => openItem(item)}
            ></SearchResultItemRepository> :
            <SearchResultItem
                item={item}
                key={index}
                index={index}
                onClick={() => openItem(item)}
            ></SearchResultItem>
        ))}
      </InfiniteScroll>
    );
};

export default SearchResults;